export interface SupabaseRequestErrorOptions {
  cause?: unknown;
  /** PostgREST / REST URL when known (e.g. from tagged fetch failures). */
  requestUrl?: string;
}

/**
 * Wraps failures originating from Supabase client calls (auth, PostgREST, etc.).
 */
export class SupabaseRequestError extends Error {
  readonly requestUrl?: string;

  constructor(message: string, options?: SupabaseRequestErrorOptions) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = "SupabaseRequestError";
    this.requestUrl = options?.requestUrl;
  }
}
